<template>
  <div>
    <datatable
      @create="createMeeting"
      @delete="deleteMeeting"
      title="Applicant Meetings"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicant-meetings',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'timing',
          value: 'timing',
          is_time: true
        },
        {
          name: 'history_company',
          value: 'history_company.name'
        },
        {
          name: 'applicant_message',
          value: 'applicant_message'
        },
        {
          name: 'company_message',
          value: 'company_message'
        },
        {
          name: 'requested_interview_preparation',
          value: 'requested_interview_preparation'
        }
      ],
      data: [],
      operations: [],
      applicant_id: this.$route.query.applicant_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceMeetings({
          current_type: 'Applicant',
          current_resource_id: this.applicant_id
        })
        .then(response => {
          this.data = response
        })
    },
    deleteMeeting (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.history_company.name,
        item_name: delete_data.history_company.name,
        method: 'deleteMeeting',
        method_params: { id: delete_data.id, current_type: 'Applicant', current_resource_id: this.applicant_id }
      })
    },
    createMeeting () {
      this.create({ designator: 'applicant-meetings-form-modal', component_name: 'ApplicantMeetingsForm', is_create: true, applicant_id: this.applicant_id, modal_title: 'Create new Meeting' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-meetings-form-modal', component_name: 'ApplicantMeetingsForm', data, applicant_id: this.applicant_id, modal_title: data.history_company.name + ' Meeting' })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
